import type { Span } from "../../bridge/binary";
import { useBinaryReader } from "../../bridge/binary";
import { createProxies } from "./proxies";

export interface SmartLinkListItem {
  id: string;
  x: number;
  y: number;
  width: number;
  height: number;
  url: string;
  embedUrl: string;
  // title: string;
}

export interface SmartLinkList {
  items: SmartLinkListItem[];
}

interface SmartLinkExportsMethods {
  GetAll: () => Span<SmartLinkList>;
  GetActive: () => Span<SmartLinkList>;
  GetById: (id: string) => Span<SmartLinkListItem>;
  Activate: (id: string) => Promise<void>;
  Deactivate: (id: string) => Promise<void>;
  // SetSmartLinkUrl: (id: string, url: string, embedUrl: string, title: string, thumbnailImage?: string) => Promise<void>;
  SetSmartLinkUrl: (id: string, url: string, embedUrl: string) => Promise<void>;
  ConvertSmartLinkToTextBox: (id: string) => Promise<void>;

  CreateSmartLink: (url: string, embedUrl: string) => Promise<void>;
}

export interface SmartLinkExports {
  SmartLink: SmartLinkExportsMethods;
}

export interface SmartLinkMetadata {
  title: string;
  thumbnailImage: string | undefined;
}

const {
  setup,
  getActive: getActiveProxy,
  getAll: getAllProxy,
  getById: getByIdProxy,
  activate,
  deactivate,
  setSmartLinkUrl,
  convertSmartLinkToTextBox,
  createSmartLink,
} = createProxies<SmartLinkExportsMethods>([
  "GetAll",
  "GetActive",
  "GetById",
  "Activate",
  "Deactivate",
  "SetSmartLinkUrl",
  "ConvertSmartLinkToTextBox",
  "CreateSmartLink",
]);

const getAll = useBinaryReader(getAllProxy);
const getActive = useBinaryReader(getActiveProxy);
const getById = useBinaryReader(getByIdProxy);

export {
  activate,
  convertSmartLinkToTextBox,
  createSmartLink,
  deactivate,
  getActive,
  getAll,
  getById,
  setSmartLinkUrl,
  setup,
};
